const FileIcon = ({ className, stroke }) => {
  return (
    <svg
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M2.25 5C2.25 3.11438 2.25 2.17157 2.8724 1.58579C3.4948 1 4.49653 1 6.5 1H6.88636C8.51697 1 9.33227 1 9.89847 1.39892C10.0607 1.51321 10.2047 1.64876 10.3261 1.80144C10.75 2.33434 10.75 3.10168 10.75 4.63636V5.90909C10.75 7.39068 10.75 8.13147 10.5155 8.72313C10.1386 9.67429 9.34143 10.4246 8.33082 10.7793C7.70219 11 6.91509 11 5.34091 11C4.44137 11 3.99161 11 3.63239 10.8739C3.0549 10.6712 2.59938 10.2425 2.38398 9.69893C2.25 9.36084 2.25 8.93753 2.25 8.09091V5Z"
        stroke={stroke || "#182443"}
        strokeLinejoin="round"
      />
      <path
        d="M10.75 6C10.75 6.92047 10.0038 7.66667 9.08333 7.66667C8.75044 7.66667 8.35798 7.60834 8.03432 7.69506C7.74674 7.77212 7.52212 7.99674 7.44506 8.28432C7.35834 8.60798 7.41667 9.00044 7.41667 9.33333C7.41667 10.2538 6.67047 11 5.75 11"
        stroke={stroke || "#182443"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.5 3.5H8"
        stroke={stroke || "#182443"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.5 5.5H6"
        stroke={stroke || "#182443"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default FileIcon;
